import React from 'react';
import { images } from '../data/site';
interface LogoProps {
  tone?: 'dark' | 'light';
}
export function Logo({
  tone = 'dark'
}: LogoProps) {
  return <a href="#home" className="flex items-center gap-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ice focus-visible:ring-offset-4" aria-label="Hold Fast Hauling — home" data-id="element-295" data-mp="8v67f48754bx">
      <img src={images.logo} alt="Hold Fast Hauling compass logo" className="h-[4.5rem] w-auto" style={{
      filter: `contrast(1.3) ${tone === 'light' ? 'url(#hf-logo-white)' : 'url(#hf-logo-ink)'}`,
      // Trims the dark edge artifacts baked into the source file's left/right borders.
      clipPath: 'inset(1.5% 3% 1.5% 3%)'
    }} data-id="element-296" data-mp="msuqq7mm83ev" />
      <span className={`hidden text-[10px] font-bold uppercase leading-tight tracking-[0.18em] sm:block ${tone === 'dark' ? 'text-ink-soft' : 'text-white/60'}`} data-id="element-297" data-mp="hvm49uufpd7t">
        Temperature
        <br data-id="element-298" data-mp="1eurpq4fouvmi" />
        Controlled OTR
      </span>
    </a>;
}